<style lang="scss" scoped>
::v-deep .feed-content {
    flex-grow: 1;
    margin-bottom: 32px;
}
</style>
<template>
    <div>
        <div class="px-0 px-md-44 pt-16 pt-md-32 h-100">
            <!-- Content -->
            <div class="row h-100">
                <div class="col-12 col-xl-8 order-2 order-md-2 h-100 d-flex flex-column">

                    <!-- MOTD -->
                    <div class="w-100 rounded-sm p-24 bg-white-hover mb-32 d-none d-md-block">
                        <h4 class="mb-md-24 fw-b text-dark">Goedemiddag {{ currentUser.first_name }}.</h4>
                        <div class="d-none d-md-block">
                            <router-link v-if="currentUser.permissions.includes('user.invite')" :to="{ name: 'admin-add-patient' }" class="btn btn-outline-gold mr-24">
                                {{ $t('pages.dashboard.add_patient') }}
                            </router-link>
                            <router-link v-if="currentUser.permissions.includes('discount_code.create')" :to="{ name: 'admin-codes-add' }" class="btn btn-outline-gold mr-24">
                                {{ $t('pages.dashboard.add_code') }}
                            </router-link>
                            <router-link v-if="currentUser.permissions.includes('psychologist.invite')" :to="{ name: 'admin-psychologists-add' }" class="btn btn-outline-gold">
                                {{ $t('pages.dashboard.add_psychologists') }}
                            </router-link>
                        </div>
                    </div>

                    <!-- Feed -->
                    <div class="row flex-grow-1">
                        <div class="d-flex flex-column w-100">
                            <div class="col-12 flex-none">
                                <div class="d-flex mb-24">
                                    <i-bell class="i-14 mr-8 my-auto"></i-bell>
                                    <p class="text-dark fw-b">{{ $t('pages.dashboard.notifications') }}</p>
                                </div>
                            </div>
                            <div class="col-12 flex-none flex-grow-1">
                                <feed :numbers="action_totals" class="h-100 d-flex flex-column"></feed>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="col-12 col-xl-4 order-1 order-md-2 mb-32 mb-md-0">
                    <div class="row">
                        <div class="col-12 col-lg-6 mb-24">
                            <div class="bg-white-hover rounded-sm text-center p-24">
                                <h2 class="fw-b text-primary-dark mb-8">{{ statistics.active_users_today }}</h2>
                                <p class="small text-primary-dark">{{ $t('pages.dashboard.active_users_today') }}</p>
                            </div>
                        </div>
                        <div class="col-12 col-lg-6 mb-24">
                            <div class="bg-white-hover rounded-sm text-center p-24">
                                <h2 class="fw-b text-primary-dark mb-8">{{ statistics.new_users_today }}</h2>
                                <p class="small text-primary-dark">{{ $t('pages.dashboard.new_users_today') }}</p>
                            </div>
                        </div>
                        <div class="col-12">
                            <div v-if="chartdata" class="bg-white-hover rounded-sm p-24">
                                <div class="row">
                                    <div class="col-6 my-auto">
                                        <p class="fw-b text-dark mb-24"> {{ $t('pages.dashboard.new_users') }} </p>
                                    </div>
                                    <div class="col-6">
                                        <el-select class="small" name="selectedMonth" v-model="current_month" @input="getStatistics()" :options="months" :hasLabel="false"></el-select>
                                    </div>
                                </div>
                                <line-chart :chart-data="chartdata" :height="225"></line-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { ElSelect } from '@/components/forms'
import Feed from '@/components/feed/feed'
import { LineChart } from '@/components/charts'

export default {
    name: 'page-admin-dashboard',

    components: { ElSelect, LineChart, Feed },

    data: () => ({
        search: '',
        actions: [],
        chartdata: null,
        current_month: null,
        months: [],
        action_totals: {
            total: 0,
            total_none: 0,
            total_medium: 0,
            total_high: 0,
            total_todo: 0,
            total_done: 0
        }
    }),
    mounted() {
        for (let i = 0; i < 12; i++) {
            let month = this.$moment().set('month', i)
            this.months.push({ value: parseInt(month.format('M')), label: month.format('MMMM') })
        }
        this.current_month = this.months[this.$moment().month()]

        this.$store.dispatch('statistics/read').then(() => {
            this.getStatistics()
        })
        this.$store.dispatch('statistics/actionStatistics').then((totals) => {
            this.action_totals = totals
        })
    },

    methods: {
        getStatistics() {
            return new Promise((resolve) => {
                let result = {};
                const currentMonthDates = Array.from({ length: this.$moment().daysInMonth() }, (x, i) => this.$moment().set('month', this.current_month.value - 1).startOf('month').add(i, 'days'));

                currentMonthDates.forEach(day => {
                    result[day.format('D')] = null
                    if (day.isBefore(this.$moment())) {
                        result[day.format('D')] = 0
                    }

                    this.statistics.users.forEach(d => {
                        if (this.$moment(d.date, 'YYYY-MM-DD').isSame(day.format('YYYY-MM-DD'), 'day')) result[day.format('D')] = d.registrations
                    })
                })

                this.chartdata = {
                    labels: Object.keys(result),
                    datasets: [
                        {
                            lineTension: 0,
                            backgroundColor: 'transparent',
                            borderColor: '#0f3261',
                            borderWidth: 4,
                            pointBorderColor: 'transparent',
                            data: Object.values(result)
                        }
                    ]
                }

                resolve()
            })
        }
    },
    computed: {
        statistics() {
            return this.$store.getters['statistics/all']
        },
        currentUser() {
            return this.$store.getters['user/currentUser']
        }
    }
}
</script>
